<div class="suppliers-tree">
  @if (label()) {
    <div class="suppliers-tree__label">
      {{ label() }}
    </div>
  }
  <procure-loading-indicator [active]="isLoading()" />
  <div class="suppliers-tree__items">
    <div class="suppliers-tree__item suppliers-tree__item--level-1">
      <div class="suppliers-tree__item-detail">
        @if (stucture()?.children?.length) {
          <mat-icon
            class="suppliers-tree__toggle"
            (click)="toggleExpansion(stucture())"
          >
            {{
              (expanded() | contains: expansionKey(stucture())) && stucture()?.children?.length
                ? "expand_more"
                : "chevron_right"
            }}
          </mat-icon>
        }
        @if (!stucture()?.isVirtual) {
          <a
            class="suppliers-tree__item-label"
            [routerLink]="['/suppliers', stucture()?.id]"
            [class.suppliers-tree__item-label--current]="stucture()?.id === currentId()"
          >
            {{ supplierDisplay(stucture(), true) }}
          </a>
        } @else {
          <mat-icon
            class="suppliers-tree__label-icon"
            aria-label="Warning"
            matTooltip="This Supplier is detached and doesn't exist in SAP Ariba anymore."
          >
            warning
          </mat-icon>
          <div class="suppliers-tree__item-label">
            {{ supplierDisplay(stucture(), true) }}
          </div>
        }
        @if (!isLoading() && stucture()) {
          <procure-number-badge
            class="suppliers-tree__count"
            matTooltip="Number of affiliated companies."
            [value]="companiesCount()"
          />
        }
      </div>
      <ng-container *ngTemplateOutlet="treeStructure; context: { item: stucture(), level: 2 }" />
    </div>
  </div>
</div>
<ng-template
  #treeStructure
  let-item="item"
  let-level="level"
>
  @if (expanded() | contains: expansionKey(item)) {
    @for (child of item.children; track child.id) {
      <div [class]="`suppliers-tree__item suppliers-tree__item--level-${level}`">
        <div class="suppliers-tree__item-detail">
          @if (child.children?.length) {
            <mat-icon
              class="suppliers-tree__toggle"
              (click)="toggleExpansion(child)"
            >
              {{
                (expanded() | contains: expansionKey(child)) && child?.children?.length
                  ? "expand_more"
                  : "chevron_right"
              }}
            </mat-icon>
          }
          @if (child.isFolder) {
            <mat-icon
              class="suppliers-tree__folder"
              [class.suppliers-tree__folder--disabled]="!child.children?.length"
              (click)="toggleExpansion(child)"
            >
              folder
            </mat-icon>
            <div class="suppliers-tree__item-label suppliers-tree__item-label--country">{{ child.name }}</div>
          } @else {
            <div class="suppliers-tree__item-label suppliers-tree__item-label--child">
              <a
                class="text-link"
                [routerLink]="['/supplier', child.id]"
                [class.suppliers-tree__item-label--current]="child.id === currentId()"
              >
                {{ supplierDisplay(child) }}
              </a>
            </div>
          }
        </div>
        <ng-container *ngTemplateOutlet="treeStructure; context: { item: child, level: level + 1 }" />
      </div>
    }
  }
</ng-template>
